import * as yup from 'yup';

export interface ILevelFormValues {
  clientId: string;
  clientSecret: string;
}

export function iLevelConfigSchema(isExistingConfig: boolean) {
  return yup.object({
    clientId: yup.string().trim().required('Client ID is required'),
    clientSecret: isExistingConfig
      ? yup.string().default('')
      : yup.string().trim().required('Client Secret is required'),
  });
}

export function getDefaultILevelConfig(): ILevelFormValues {
  return {
    clientId: '',
    clientSecret: '',
  };
}
